<template>
  <div class="pa-4">
    <div class="d-flex justify-space-between align-center mb-4">
      <div class="text-subtitle-1 font-weight-bold primary--text">
        <v-icon left color="primary">mdi-format-list-bulleted-type</v-icon> TỔNG HỢP TỒN KHO THEO VỊ TRÍ
      </div>
      <v-btn icon small @click="loadData" :loading="loading" title="Tải lại">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>

    <v-row dense class="mb-4">
      <v-col cols="12" md="4" v-for="loc in locationStockList" :key="loc.locationId">
        <v-card outlined class="pa-4" hover>
          <div class="d-flex justify-space-between align-center">
            <div>
              <v-chip x-small :color="loc.locationType === 'WAREHOUSE' ? 'indigo' : 'teal'" dark class="mb-1">
                {{ loc.locationType === 'WAREHOUSE' ? 'KHO LƯU TRỮ' : 'PHÒNG HỌC' }}
              </v-chip>
              <div class="text-h6 font-weight-bold">{{ loc.locationName }}</div>
              <div class="grey--text caption">Mã: {{ loc.locationCode }}</div>
            </div>
            <div class="text-right">
              <div class="text-h5 font-weight-black primary--text">{{ loc.totalAvailable }} / {{ loc.totalQuantity }}</div>
              <div class="caption grey--text">Khả dụng / Tổng tồn</div>
            </div>
          </div>
          <v-divider class="my-2" />
          <div class="caption grey--text">
            <span>{{ loc.itemCount }} loại thiết bị lưu trữ</span>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AssetTransaction } from '@/plugins/api'

export default {
  name: 'StockByLocationTable',
  data() {
    return {
      loading: false,
      locationStockList: []
    }
  },
  async created() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await AssetTransaction.getStockByLocation()
        this.locationStockList = (res && res.data) || []
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
